import React from "react";
import { Route } from "react-router-dom";
import { RequireModuleAccess } from "../../app/session/RequireModuleAccess.js";
import DevToolsPage from "./pages/DevToolsPage.js";

export const devToolsRoutes = (
  <Route element={<RequireModuleAccess module="dev-tools" />}>
    <Route path="/dev-tools" element={<DevToolsPage />} />
  </Route>
);
